import api from './api';

/*
 * /uiapi/inventory/* (server r16/inventory, spec 01.4 section 5). Every call is scoped by the SERVER to what the
 * logged-in user may see; nothing here filters for access. Reveal is a POST (CSRF-protected, never cached).
 */
const BASE = '/inventory';

export const inventoryApi = {
  meta: () => api.get(`${BASE}/meta`),
  list: (table, params = {}) => api.get(`${BASE}/${table}`, { params: { size: 1000, ...params } }),
  get: (table, id) => api.get(`${BASE}/${table}/${id}`),
  create: (table, body) => api.post(`${BASE}/${table}`, body),
  update: (table, id, body) => api.put(`${BASE}/${table}/${id}`, body),
  archive: (table, id) => api.delete(`${BASE}/${table}/${id}`),
  restore: (table, id) => api.post(`${BASE}/${table}/${id}/restore`, {}),
  bulk: (table, ids, set) => api.post(`${BASE}/${table}/bulk`, { ids, set }),
  bulkGroups: (ids, add = [], remove = []) => api.post(`${BASE}/accounts/bulk-groups`, { ids, add, remove }),
  lookup: (table, q) => api.get(`${BASE}/lookup/${table}`, { params: q ? { q } : {} }),
  importCsv: (table, csv, dryRun) => api.post(`${BASE}/${table}/import`, { csv, dryRun: !!dryRun }),
  exportCsv: (table, params = {}) => api.get(`${BASE}/${table}/export`, { params, responseType: 'blob' }),
  credentialFlags: (accountId) => api.get(`${BASE}/accounts/${accountId}/credential`),
  setCredential: (accountId, values) => api.put(`${BASE}/accounts/${accountId}/credential`, values),
  revealCredential: (accountId, fields) => api.post(`${BASE}/accounts/${accountId}/credential/reveal`, fields ? { fields } : {}),
  setNetworkSecret: (networkId, values) => api.put(`${BASE}/network/${networkId}/secret`, values),
  revealNetworkSecret: (networkId, fields) => api.post(`${BASE}/network/${networkId}/secret/reveal`, fields ? { fields } : {}),
  // Phase 3: capacity, assign / move with undo, the Problems board, alerts (all scoped by the server).
  capacity: (params = {}) => api.get(`${BASE}/capacity`, { params }),
  assign: (body) => api.post(`${BASE}/assign`, body),
  undoAssign: (opId, body = {}) => api.post(`${BASE}/assign/${opId}/undo`, body),
  assignments: (params = {}) => api.get(`${BASE}/assignments`, { params }),
  problems: (params = {}) => api.get(`${BASE}/problems`, { params }),
  alerts: (params = {}) => api.get(`${BASE}/alerts`, { params }),
  alertScan: () => api.post(`${BASE}/alerts/scan`, {}),
  digestPreview: () => api.get(`${BASE}/alerts/digest`),
};

/** The server's explanation of a failed call (the api interceptor fills `detail` from `error`). */
export function errorText(e, fallback = 'Request failed') {
  return e?.response?.data?.detail || e?.response?.data?.error || e?.message || fallback;
}

/** Saves a Blob as a file in the browser. */
export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
